module.exports=function(scope){ return `curl -X GET "https://your.internal.facetec.standard.server.instance.url/status"
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/bash/test-connection.bash.tpl